/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VerticalType = "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type SuspectedTradeUserLoader_itemSearch = {
    readonly topCategoryL1: VerticalType | null;
    readonly " $refType": "SuspectedTradeUserLoader_itemSearch";
};
export type SuspectedTradeUserLoader_itemSearch$data = SuspectedTradeUserLoader_itemSearch;
export type SuspectedTradeUserLoader_itemSearch$key = {
    readonly " $data"?: SuspectedTradeUserLoader_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SuspectedTradeUserLoader_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SuspectedTradeUserLoader_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "topCategoryL1",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'dd1ea83a88234e46adaa0f0099c529a2';
export default node;
